// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".list_container{width:100%;display:flex;flex-direction:column}.list_heading{font-size:18px;line-height:22px;margin-bottom:23px}\n", ""]);
// Exports
module.exports = exports;
